import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505867",
      d: "M17 1.5a.5.5 0 0 1 .5.5v16l-.01.098a.5.5 0 0 1-.49.402H3a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5zm-13.5 16h13v-15h-13zm11-13.875c.207 0 .375.168.375.375v3a.375.375 0 0 1-.375.375h-9A.375.375 0 0 1 5.125 7V4c0-.207.168-.375.375-.375zm-2.625 3h2.25v-2.25h-2.25zm-3 0h2.25v-2.25h-2.25zm-3 0h2.25v-2.25h-2.25z",
      style: {"fill":"color(display-p3 .3137 .3451 .4039)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#505867",
      d: "M6 9.625C6 9.004 6.504 8.5 7.125 8.5h1.25c.621 0 1.125.504 1.125 1.125v1.25C9.5 11.496 8.996 12 8.375 12h-1.25A1.125 1.125 0 0 1 6 10.875zM6 14.125C6 13.504 6.504 13 7.125 13h1.25c.621 0 1.125.504 1.125 1.125v1.25c0 .621-.504 1.125-1.125 1.125h-1.25A1.125 1.125 0 0 1 6 15.375zM10.5 9.625c0-.621.504-1.125 1.125-1.125h1.25c.621 0 1.125.504 1.125 1.125v1.25c0 .621-.504 1.125-1.125 1.125h-1.25a1.125 1.125 0 0 1-1.125-1.125zM12.625 13.375a.375.375 0 0 0-.75 0v1h-1a.375.375 0 0 0 0 .75h1v1a.375.375 0 0 0 .75 0v-1h1a.375.375 0 0 0 0-.75h-1z",
      style: {"fill":"color(display-p3 .3137 .3451 .4039)","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }